import { useRouter } from "next/router";

const useQueryParams = () => {
  const router = useRouter();

  const match =
    typeof router.query.match === "string" ? router.query.match : "";
  const date = typeof router.query.date === "string" ? router.query.date : "";
  const shopUuid =
    typeof router.query.uuid === "string" ? router.query.uuid : "";

  return {
    match,
    date,
    shopUuid,
  };
};

export default useQueryParams;
